import React from 'react';
import FamilyProfileSection from './settings/FamilyProfileSection';

const FamilyPage: React.FC = () => {
  return (
    <div className="space-y-6 p-6">
      <FamilyProfileSection defaultTab="members" />
    </div>
  );
};

export default FamilyPage;